/**
 * pdfEngine.js
 * Abstraction layer for PDF generation.
 *
 * Current engine: "print" — opens a new window and calls window.print().
 * Future engines (set via REACT_APP_PDF_ENGINE env var):
 *   "pdfshift"  — POST HTML to PDFShift API (~$9/month, 250 conversions)
 *   "puppeteer" — POST HTML to self-hosted Puppeteer server (e.g. Railway)
 *
 * Switching engines requires zero changes to RetirementReportPage.jsx.
 */

const ENGINE = process.env.REACT_APP_PDF_ENGINE || "print";
const PDF_SERVER = process.env.REACT_APP_PDF_SERVER || "";
const PDFSHIFT_KEY = process.env.REACT_APP_PDFSHIFT_KEY || "";

// ── Public API ────────────────────────────────────────────────────────────────
export async function openReport(htmlString) {
  if (ENGINE === "pdfshift") return pdfShiftEngine(htmlString);
  if (ENGINE === "puppeteer") return puppeteerEngine(htmlString);
  return printEngine(htmlString);
}

// ── Engine: window.print() ────────────────────────────────────────────────────
// Does NOT auto-print — the HTML includes a notes UI + print button.
function printEngine(html) {
  const w = window.open("", "_blank");
  if (!w) {
    alert("הדפדפן חסם את פתיחת החלון. אנא אפשר popups לאתר זה.");
    return;
  }
  w.document.write(html);
  w.document.close();
  w.focus();
}

// ── Engine: PDFShift API ─────────────────────────────────────────────────────
// Usage: set REACT_APP_PDF_ENGINE=pdfshift and REACT_APP_PDFSHIFT_KEY=your_key
async function pdfShiftEngine(html) {
  const res = await fetch("https://api.pdfshift.io/v3/convert/pdf", {
    method: "POST",
    headers: {
      Authorization: `Basic ${btoa("api:" + PDFSHIFT_KEY)}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ source: html, format: "A4", margin: "15mm" }),
  });
  if (!res.ok) throw new Error(`PDFShift error: ${res.status}`);
  downloadBlob(await res.blob(), "retirement-plan.pdf");
}

// ── Engine: Puppeteer server (Railway / self-hosted) ──────────────────────────
// Usage: set REACT_APP_PDF_ENGINE=puppeteer and REACT_APP_PDF_SERVER=https://...
async function puppeteerEngine(html) {
  const res = await fetch(`${PDF_SERVER}/api/pdf`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ html, format: "A4" }),
  });
  if (!res.ok) throw new Error(`PDF server error: ${res.status}`);
  downloadBlob(await res.blob(), "retirement-plan.pdf");
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  Object.assign(document.createElement("a"), { href: url, download: filename }).click();
  URL.revokeObjectURL(url);
}
